<template>
<h6 > <i class="material-icons md-18 md-light md-inactive bulb">wb_incandescent</i>
<br> 
<div class="textSize">
<div >LEARN </div> 
<div > MORE</div> 
 </div> 
 </h6>
</template>

<script>
import { mapGetters } from "vuex";
import Cookies from "js-cookie";
export default {
  props: {
    linePerWord: Boolean,
    text: String,
    number:String
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {
    
  },
  computed: {
  }
};
</script>
<style  lang="scss" scoped>
.material-icons.md-18 {
  font-size: 21px;
}
.material-icons.md-light.md-inactive {
  color: rgba(255, 255, 255, 0.3);
}
.material-icons.md-light:hover {
  color: #f6b63a;
}
.active.logo + .menuItems {
  height: 192px;
  width: 657;
  .brand {
    height: 192px;
    width: 94px;
    .textSize{
     div{display: block;}
    }
  }
}

.menuItems {
  float: left;
  height: 59px;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  align-self: flex-end;
  background-color: #000000;
  justify-content: flex-start;
  align-items: center;

  .brand {
    margin: 0;
    padding: 0;
    height: 59px;
    width: 98.5px;
    flex-grow: 1;
    display: flex;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-align-items: center;
    align-items: center;
    .bulb{ 
      margin-top: 3px;
      transform: rotate(180deg);
    }
    h6{
     .textSize {
      height: 17px;
      letter-spacing: 1.7px;
      font-size: 12px;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      color: #fff;
      display: inline;
      div{
        display: inline;
      }
    }
    }
    float: left;
    position: relative;
  }
}

h6,
h2 {
  font-family: "BentonSansBold";
  letter-spacing: 1px;
  line-height: 18px;
  span {
    color: #fab82c;
  }
}

.brand:hover h6 .number {
  opacity: 1;
  color: #fab82c;
}

.brand:hover h6 .bulb {
  opacity: 1;
  color: #fab82c;
}
.brand:hover h6 .textSize {
  color: #fab82c;
}
.active.brand:hover h6 .textSize {
  color: #ffffff;
}

.active.logo {
  border-right: 1px solid #212121;
  border-left: 10px solid #fab82c;
  width: 366px;
  height: 370px;
  background-color: #000000;
  justify-content: center;
  align-items: center;
  font-size: 30px;
    
  h2 {
    opacity: 1;
    line-height: 33px;
    margin-top: 5px;
    left: 72px;
    display: block;
    font-size: 30px;
    letter-spacing: 1.7px;
    span {
      opacity: 1;
      font-family: BentonSansBold;
      font-size: 30px;
    }
  }

  img {
    object-fit: contain;
    margin-left: -23px;
    margin-top: 21px;
    margin-right: 90px;
    width: 225px;
    height: 79px;
  }
}

.active.brand {
  display: flex;
  border-top: 5px solid #fab82c;
  border-right: 0.1px solid rgba(151, 151, 151, 0.4);
  border-left: 0.1px solid rgba(151, 151, 151, 0.4);
  justify-content: center;
  align-items: center;
  width: 217px;

  h6 {
     .textSize {
      opacity: 1;
      letter-spacing: 2.8px;
      font-size: 20px;
      color: #fff;
    }
    .bulb {
      margin-right: 20px;
      margin-top: 5px;
      color: #fab82c;
    }
    .number {
      opacity: 1;
      letter-spacing: 1.2px;
      font-size: 22px;
      color: #fab82c;
      margin-right: 20px;
    }
    br {
      display: none;
    }
  }
}
</style>

